import UiIcon from './UiIcon.vue';
export default {
  name: 'ThemeControl',
  components: {
    UiIcon
  },
  data: () => ({
    modes: [{
      value: 'light',
      icon: 'sun'
    }, {
      value: 'dark',
      icon: 'moon'
    }, {
      value: 'system',
      icon: 'monitor'
    }]
  }),
  computed: {
    selected() {
      return !this.$store.state.cusDarkMode ? 'system' : this.$store.state.useDarkMode ? 'dark' : 'light';
    }
  },
  methods: {
    select(mode) {
      this.$store.commit('setCusDarkMode', mode !== 'system');
      this.$store.commit('setUseDarkMode', mode === 'system' ? window.matchMedia('(prefers-color-scheme: dark)').matches : mode === 'dark');
    }
  }
};